import type { WidaStudent } from '../Upload/widaHistory';
import type { SisStudent } from '../Upload/sisRoster';

function findSisIndex(sis: SisStudent[], candidateIds: string[]): number | null {
  for (const candidate of candidateIds) {
    const id = candidate.trim();
    if (id === '') continue;
    const idx = sis.findIndex((s) => s.studentId === id || s.altIds.includes(id));
    if (idx !== -1) return idx;
  }
  return null;
}

export function countSisMatched(wida: WidaStudent[], sis: SisStudent[]): number {
  let matched = 0;
  for (const student of wida) {
    const idx = findSisIndex(sis, [student.stateStudentId, student.localStudentId, student.id]);
    if (idx != null) matched += 1;
  }
  return matched;
}
